<input matInput
    #groupNameInput
    [id]="id"
    [value]="getGroupName(value)"
    [formControl]="groupNameCtrl"
    [placeholder]="placeholder"    
    (focus)="onTouched($event); openDropdown();"
    autocomplete="off">